'use strict';
/**
 * @author Maxim Seredkin
 */
export default function() {
    return {
        restrict: 'A',
        template: require('../view/project-team.html'),
        transclude: true,
        scope: {
            selectedItem: '=?myValue',
            items: '=?myItems',
            ok: '=?myOk',
            project: '=myProject',
            edit: '=edit',
            filter: '=?myFilter'
        },
        controller: ['$scope', '$utils', '$uibModal', 'ProjectService', 'Notification', '$location', '$security', '$log', 'StaffService', 'OrgService',
                     function($scope, $utils, $modal, ProjectService, Notification, $location, $security, $log, StaffService, OrgService) {
                         $scope.oivFilters = [`'oiv' EQ 'true'`];
                         $scope.oivDef = {};

                         $scope.curatorOivFilters = [];
                         $scope.curatorOivDef = {};

                         $scope.omsuFilters = [`'omsu' EQ 'true'`];
                         $scope.omsuDef = {};

                         $scope.coordorgFilters = [`'coordorg' EQ 'true'`];
                         $scope.coordinatorFilters = [];
                         $scope.coordinatorDef = {};

                         $scope.mizipFilters = [`'mizip' EQ 'true'`];
                         $scope.curatorMizipFilters = [`'org.mizip' EQ 'true'`];
                         $scope.curatorMizipDef = {};

                         $scope.managerFilters = [`EXTRA:'role' EQ 'PROJECT_MANAGER'`, `EXTRA:'role' EQ 'ADMINISTRATOR'`];

                         $scope.contactFilters = [];
                         $scope.contactDef = {};

                         $scope.municipalityOrgFilters = [];
                         $scope.municipalityStaffFilters = [];
                         $scope.municipalityStaffDef = {};

                         $scope.removeContact = removeContact;
                         $scope.addContact = addContact;
                         $scope.removeOiv = removeOiv;
                         $scope.addOiv = addOiv;
                         $scope.removeCurator = removeCurator;
                         $scope.addCurator = addCurator;
                         $scope.addOivCurator = function (contact) {
                            $scope.curatorOivFilters = [`'org.id' EQ '${contact.oiv.id}'`];
                            $scope.curatorOivDef = {org: contact.oiv};
                            StaffService.select({}, $scope.curatorOivFilters, $scope.curatorOivDef).result.then((data) => {
                                if (!Array.isArray($scope.project.oivs)) {
                                    $scope.project.oivs = [];
                                }
                                if (!!contact) {
                                    $scope.project.oivs[$scope.project.oivs.findIndex(oiv => oiv.oiv.id === contact.oiv.id)].curator = data;
                                }
                            });
                        }
                         $scope.sec = $security;

                         function removeContact(contact) {
                             $scope.project.projectContacts.splice($scope.project.projectContacts.indexOf(contact), 1);
                         }

                         function addContact() {
                             StaffService.select({}, $scope.contactFilters, $scope.contactDef).result.then((data) => {
                                 if (!Array.isArray($scope.project.projectContacts)) {
                                     $scope.project.projectContacts = [];
                                 }

                                 if (!$scope.project.projectContacts.some((contact) => contact.id === data.id)) {
                                     $scope.project.projectContacts.push(data);
                                 }
                             });
                         }

                         function addOiv(contact) {
                            OrgService.select({}, $scope.oivFilters, $scope.oivDef).result.then((data) => {
                                if (!Array.isArray($scope.project.oivs)) {
                                    $scope.project.oivs = [];
                                }

                                // if (!$scope.project.oivs.some((contact) => contact.id === data.id)) {
                                //     $scope.project.oivs.push(data);
                                // }

                                if (!!contact) {
                                    $scope.project.oivs[$scope.project.oivs.findIndex(oiv => oiv.oiv.id === contact.oiv.id)].oiv = data;
                                } else if (!$scope.project.oivs.some((contact) => contact.oiv.id === data.id)) {
                                    $scope.project.oivs.push({ oiv: data, curator: null });
                                }
                            });
                        }

                        function removeOiv(contact, field) {
                            if (field === 'oiv') {
                                $scope.project.oivs.splice($scope.project.oivs.findIndex(oiv => oiv.oiv.id === contact.oiv.id), 1);
                            } else if (field === 'curator') {
                                $scope.project.oivs[$scope.project.oivs.findIndex(oiv => oiv.curator.id === contact.curator.id)].curator = null;
                            }
                        }

                         function removeCurator(curator) {
                             $scope.project.curatorsMizip.splice($scope.project.curatorsMizip.indexOf(curator), 1);
                         }

                         function addCurator() {
                             StaffService.select({}, $scope.curatorMizipFilters, $scope.curatorMizipDef).result.then((data) => {
                                 if (!Array.isArray($scope.project.curatorsMizip)) {
                                     $scope.project.curatorsMizip = [];
                                 }

                                 if (!$scope.project.curatorsMizip.some((curator) => curator.id === data.id)) {
                                     $scope.project.curatorsMizip.push(data);
                                 }
                             });
                         }

                         // region Watcher

                         $scope.$watch('project.author', function(nw, old) {
                            if (nw) {
                                //$scope.project.oivs = [];
                            }
                            if (nw) {
                                $scope.contactFilters = [`'org.id' EQ '${nw.id}'`];
                                $scope.contactDef = {org: nw};
                            } else {
                                $scope.contactFilters = [];
                                $scope.contactDef = {};
                            }
                            if ((nw == null) || (old != null && old.id != nw.id)) {
                                angular.copy([], $scope.project.projectContacts);
                            }
                         });

                         $scope.$watch('project.coordorg', function(nw, old) {
                             if (nw) {
                                 $scope.coordinatorFilters = [`'org.id' EQ '${nw.id}'`];
                                 $scope.coordinatorDef = {org: nw};
                             } else {
                                 $scope.coordinatorFilters = [];
                                 $scope.coordinatorDef = {};
                             }
                             if ((nw == null) || (old != null && old.id != nw.id)) {
                                 angular.copy({}, $scope.project.coordinator);
                             }
                         });

                         $scope.$watch('project.municipalityOrg', function(nw, old) {
                             if (nw) {
                                 $scope.municipalityStaffFilters = [`'org.id' EQ '${nw.id}'`];
                                 $scope.municipalityStaffDef = {org: nw};
                             } else {
                                 $scope.municipalityStaffFilters = [];
                                 $scope.municipalityStaffDef = {};
                             }
                             if ((nw == null) || (old != null && old.id != nw.id)) {
                                 angular.copy({}, $scope.project.municipalityStaff);
                             }
                         });

                         // endregion
                     }],
    };
}
